<template>
  <div
    class="header"
    :class="{
      'flex justify-between gap-2': mobile && !row,
      'header-row flex row-reverse items-center justify-start gap-3': row
    }"
  >
    <h2 v-html="text" />
    <AppImg :class="{ 'pt-8' : !row }" :src="src" :alt="alt" />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  text: string;
  src: string;
  alt: string;
  row?: boolean;
}>();
const { mobile } = useBreakpoints();
</script>

<style scoped lang="scss">
.header-row {
  img {
    width: 75px;
  }
}
@media (min-width: 851px) {
  div {
    min-width: 360px;
  }
}
@media (max-width: 850px) {
  .header {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: start;
    gap: var(--space-3);
    img {
      padding-top: 0 !important;
      width: 75px;
      object-fit: contain;
    }
  }
}
</style>